import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({ selector: '[appProcessingAnimation]' })
export class ProcessingAnimationDirective implements OnChanges, OnDestroy {
  @Input() appProcessingAnimation = false;
  private readonly processingClass = 'processing-animation';
  private styleElement: HTMLStyleElement | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.addBaseStyles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.appProcessingAnimation) {
      if (this.appProcessingAnimation) {
        this.renderer.addClass(this.el.nativeElement, this.processingClass);
      } else {
        this.renderer.removeClass(this.el.nativeElement, this.processingClass);
      }
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(this.el.nativeElement, this.processingClass);
  }

  private addBaseStyles() {
    // Add the styles to the document if they don't exist
    if (!document.getElementById('processing-animation-styles')) {
      const styleEl = this.renderer.createElement('style');
      this.renderer.setProperty(styleEl, 'id', 'processing-animation-styles');
      const styles = `
        .processing-animation {
          position: relative;
          display: block;
          overflow: visible;
        }

        /* Text elements: classic shimmer (light-mode, lighter base + stretched band). */
        .processing-animation p,
        .processing-animation li,
        .processing-animation h1,
        .processing-animation h2,
        .processing-animation h3,
        .processing-animation h4,
        .processing-animation h5,
        .processing-animation h6,
        .processing-animation blockquote {
          text-align: inherit;
          color: rgba(0, 0, 0, 0.1);
          background: linear-gradient(90deg, #555 0%, #555 28%, #aaa 38%, #fff 50%, #aaa 62%, #555 72%, #555 100%);
          background-size: 200% 100%;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          text-shadow: none;
          animation: processing-shimmer 2s linear infinite;
          background-repeat: no-repeat;
          background-position: 0 0;
          background-color: #555;
        }

        /* Keep list bullet (li::before) visible — it inherits transparent otherwise. */
        .processing-animation li::before {
          background: none;
          -webkit-background-clip: unset;
          background-clip: unset;
          color: var(--accent, #5c6bc0);
          -webkit-text-fill-color: var(--accent, #5c6bc0);
          animation: none;
        }
        .theme-dark .processing-animation li::before {
          color: var(--accent, #e0e0e0);
          -webkit-text-fill-color: var(--accent, #e0e0e0);
        }

        /* Dark mode: light text, stretched shimmer band. */
        .theme-dark .processing-animation p,
        .theme-dark .processing-animation li,
        .theme-dark .processing-animation h1,
        .theme-dark .processing-animation h2,
        .theme-dark .processing-animation h3,
        .theme-dark .processing-animation h4,
        .theme-dark .processing-animation h5,
        .theme-dark .processing-animation h6,
        .theme-dark .processing-animation blockquote {
          color: rgba(255, 255, 255, 0.1);
          background: linear-gradient(90deg, #bbb 0%, #bbb 28%, #ddd 38%, #fff 50%, #ddd 62%, #bbb 72%, #bbb 100%);
          background-color: #bbb;
        }

        /* Tables: overlay only (no background-clip on cells). */
        .processing-animation table {
          position: relative;
        }
        .processing-animation table::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            transparent 0%,
            transparent 30%,
            rgba(255, 255, 255, 0.55) 50%,
            transparent 70%,
            transparent 100%
          );
          background-size: 200% 100%;
          animation: processing-shimmer 1.8s linear infinite;
          pointer-events: none;
          z-index: 1;
          mix-blend-mode: screen;
        }
        .theme-dark .processing-animation table::after {
          background: linear-gradient(
            90deg,
            transparent 0%,
            transparent 30%,
            rgba(255, 255, 255, 0.45) 50%,
            transparent 70%,
            transparent 100%
          );
        }

        .paragraph-content--processing .processing-animation {
          display: table;
          width: fit-content;
          max-width: 100%;
        }

        @keyframes processing-shimmer {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `;

      this.renderer.setProperty(styleEl, 'textContent', styles);
      this.renderer.appendChild(document.head, styleEl);
      this.styleElement = styleEl;
    }
  }
}
